export const uk = {
    'add-success': 'Продукт успешно добавлен',
    error: 'Произошла ошибка, повторите попытку'
};
